import style from './style';

const Calc = ({ setAmount, setStength, ratio, water, strength }) => {
  return (
    <form action="javascript:" class={style.calc}>
      <h3 class={style.ratio}>{ratio} Ratio</h3>
      <div class={style.inputWrapper}>
        <input
          class={style.input}
          type="number"
          id="amount"
          min={1}
          max={150}
          aria-label="Amount of coffee in fluid ounces"
          onInput={setAmount}
          defaultValue={water}
        />
        <span class={style.unit}>fl oz</span>
        <div class={style.select}>
          <select
            class={style.input}
            aria-label="Coffee strength"
            id="strength"
            onInput={setStength}
            value={strength}
          >
            <option value="mildest">Mildest</option>
            <option value="mild">Mild</option>
            <option value="medium">Medium</option>
            <option value="strong">Strong</option>
            <option value="strongest">Strongest</option>
          </select>
        </div>
      </div>
    </form>
  );
};

export default Calc;



// WEBPACK FOOTER //
// ./components/calc/index.js